import React, { useState } from 'react';
import { Button, Spinner } from '@myhealth-raccoon/components';
import { Navigate, useNavigate } from 'react-router-dom';
import { useBeforeUnload } from 'react-use';

import { ConsentEmbed } from 'src/components/ConsentEmbed';
import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { useAppointmentTypeSelector } from 'src/hooks/useAsyncSelector';
import { useBookingFlowStep } from 'src/hooks/useBookingFlowStep';

type Props = {
    nextPage: string;
}

export function Consent({ nextPage }: Props) {
    useBookingFlowStep(4);
    // show dialog before closing/reloading
    useBeforeUnload();
    const navigate = useNavigate();
    const [_error, setError] = useState<string>();
    const { data: appointmentType, isLoading } = useAppointmentTypeSelector();

    if (isLoading || !appointmentType) {
        return <Spinner />
    }
    if (!appointmentType.consentEnabled) {
        return <Navigate to={nextPage} replace />
    }
    return <>
        <ContentContainer className='flex-1 lg:flex-none'>
            <h1 className='text-2xl text-gray-900 font-semibold mb-1'>Consent Form</h1>
            <p className='text-base mb-8'>Please complete all fields in the consent form to proceed with your booking.</p>
            <ConsentEmbed
                onError={setError}
                onConfirm={() => navigate(nextPage)}
                formId={appointmentType!.consentId}
            />
        </ContentContainer>
        <StickyBottomBar>
            <Button
                onClick={() => navigate(-1)}
                className='flex-1 text-center' color='gray'>Back</Button>
        </StickyBottomBar>
    </>
}